export const clientMenus = {
	Store: [
		{
			action: "zmdi-view-dashboard",
			title: "message.home",
			label: "Old",
			path: "/dashboard",
			exact: true,
		},
		{
			action: "zmdi-shopping-cart",
			title: "message.sales",
			// active: false,
			label: "Old",
			path: "/shopping-list",
			exact: true,
		},
		{
			action: "zmdi-store",
			title: "message.store",
			active: false,
			label: "Old",
			//path: '/store',
			exact: true,
			items: [
				{
					title: "message.profile",
					exact: true,
					path: "/store",
					label: "Old",
				},
				{
					title: "message.webStore",
					exact: true,
					path: "/store-web",
					label: "Old",
				},
				{
					title: "message.telegramStore",
					exact: true,
					path: "/store-telegram",
					label: "Old",
				},
				{
					title: "message.schedule",
					exact: true,
					path: "/store-schedule",
					label: "Old",
				},
				{
					action: "zmdi-balance",
					title: "message.paymentMethods",
					active: false,
					label: "Old",
					path: "/bank-list",
					exact: true,
				},
				{
					action: "zmdi-help",
					title: "message.faq",
					// active: false,
					exact: true,
					label: "Old",
					path: "/store-faqs",
				},
			],
		},
		{
			action: "zmdi-shopping-cart",
			title: "message.products",
			// active: false,
			label: "Old",
			// path: '/products',
			exact: true,
			items: [
				{
					action: "zmdi-label",
					title: "message.catalogue",
					active: false,
					label: "Old",
					path: "/catalogues",
					exact: true,
				},
				{
					action: "zmdi-shopping-cart",
					title: "message.products",
					active: false,
					label: "Old",
					path: "/products",
					exact: true,
				},
				{
					action: "zmdi-labels",
					title: "message.extras",
					active: false,
					label: "Old",
					path: "/products-extra",
					exact: true,
				},
			],
		},
		{
			action: "zmdi-group-work",
			title: "message.myCustomers",
			// active: false,
			label: "Old",
			path: "/customers",
			exact: true,
		},
		{
			action: "zmdi-face",
			title: "message.users",
			label: "Old",
			exact: false,
			items: [
				{
					action: "zmdi-face",
					title: "message.cashiers",
					// active: false,
					label: "Old",
					path: "/cashiers",
					exact: true,
				},
				{
					title: "message.dealers",
					exact: true,
					path: "/dealers",
					label: "Old",
				},
			],
		},
		{
			action: "zmdi-local-shipping",
			title: "message.delivery",
			// active: false,
			label: "Old",
			exact: false,
			items: [
				{
					title: "message.routes",
					exact: true,
					path: "/shipping-routes",
					label: "Old",
				},
				{
					title: "message.shippings",
					exact: true,
					path: "/shippings",
					label: "Old",
				},
				// {
				// 	title: "message.deliveryCompanies",
				// 	exact: true,
				// 	path: "/linked-delivery-companies",
				// 	label: "Old",
				// },
			],
		},
		// {
		// 	action: 'zmdi-file-text',
		// 	title: 'message.reports',
		// 	active: false,
		// 	label: 'Old',
		// 	path: '/reports',
		// 	exact: true
		// },
		// {
		// 	action: 'zmdi-star',
		// 	title: 'message.plans',
		// 	active: false,
		// 	label: 'Old',
		// 	path: '/plans',
		// 	exact: true
		// }
	],
};
